import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import "./CustomerMypage.css";
import "../../styles/font.css";
import { TopMenu } from '../../component/TopMenu';

import { getCookie} from '../../utils/authUtils';
import { API_CONFIG } from '../../config/api';

export const CustomerMypage = () => {

  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userName, setUserName] = useState('');
  const [activeTab, setActiveTab] = useState('orders');
  const [userInfo, setUserInfo] = useState(null);
  const [orderHistory, setOrderHistory] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');

  const gotoMain = () => {
    navigate('/');
  }

  const goToStudioTour = () => {
    navigate('/studio-tour');
  }

  const handleLogout = () => {
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    
    setIsAuthenticated(false);
    setUserType(null);
    setUserName('');
    navigate('/');
  };

  const fetchUserInfo = async () => {
    try {
      const userId = getCookie('yournest_u_id');
      const response = await fetch(`${API_CONFIG.MAIN}/get_user_info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId })
      });
      
      if (!response.ok) throw new Error('사용자 정보 조회 실패');
      const data = await response.json();
      setUserInfo(data.userInfo);
    } catch (error) {
      console.error('사용자 정보 조회 실패:', error);
      alert('사용자 정보를 불러오는데 실패했습니다.');
    }
  };

  const fetchOrderHistory = async () => {
    try {
      const userId = getCookie('yournest_u_id');
      const response = await fetch(`${API_CONFIG.MAIN}/get_user_orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId })
      });
      
      if (!response.ok) throw new Error('주문 내역 조회 실패');
      const data = await response.json();
      setOrderHistory(data.orders);
    } catch (error) {
      console.error('주문 내역 조회 실패:', error);
      alert('주문 내역을 불러오는데 실패했습니다.');
    }
  };

  const handleSave = async () => {
    try {
      const formattedInterests = Object.fromEntries(
        Object.entries(userInfo.interests || {}).map(([key, value]) => [key, value ? 1 : 0])
      );
  
      const response = await fetch(`${API_CONFIG.MAIN}/update_user_info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: getCookie('yournest_u_id'),
          user_name: userInfo.user_name,
          user_email: userInfo.user_email,
          user_phone: userInfo.user_phone,
          ...formattedInterests
        })
      });
  
      if (!response.ok) throw new Error('회원정보 수정 실패');
      const data = await response.json();
      
      if (data.isSuccess) {
        alert('회원정보가 수정되었습니다.');
        fetchUserInfo();
      } else {
        throw new Error(data.message || '회원정보 수정 실패');
      }
    } catch (error) {
      console.error('회원정보 수정 실패:', error);
      alert('회원정보 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    const userAuthToken = getCookie('yournest_u_auth_token');
    if (!userAuthToken) {
      setIsAuthenticated(false);
      setUserType(null);
      navigate('/');
      return;
    }
    
    setIsAuthenticated(true);
    setUserType('user');
    setUserName(getCookie('yournest_u_name'));
    
    fetchUserInfo();
    fetchOrderHistory();
  }, []);

  return (
    <div className="customer-mypage">
      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />

      <div className="customer-mypage__tab-block">
        <div 
          className={`customer-mypage__tab-block-item${activeTab === 'orders' ? '--active' : ''}`}
          onClick={() => setActiveTab('orders')}>
          주문 내역
        </div>
        <div 
          className={`customer-mypage__tab-block-item${activeTab === 'profile' ? '--active' : ''}`}
          onClick={() => setActiveTab('profile')}>
          회원정보 수정
        </div>
      </div>

      {activeTab === 'orders' ? (
        <div className="customer-mypage__order-block">
          {orderHistory.map(order => (
            <div key={order.order_id} className="customer-mypage__order-block-item">
              <div className="customer-mypage__order-block-header">
                <div className="customer-mypage__order-block-date">
                  주문일: {new Date(order.created_at).toLocaleDateString()}
                </div>
                <div className="customer-mypage__order-block-status">
                  {order.payment_status === 'completed' ? '결제완료' : 
                   order.payment_status === 'pending' ? '결제대기' : 
                   order.payment_status === 'canceled' ? '취소됨' : order.payment_status}
                </div>
              </div>
              <div className="customer-mypage__order-block-content">
                <div className="customer-mypage__order-block-title">
                  {order.tour_name}
                </div>
                <div className="customer-mypage__order-block-info">
                  예약일시: {new Date(order.reservation_date).toLocaleDateString()} {order.reservation_time}
                </div>
                <div className="customer-mypage__order-block-info">
                  인원: {order.number_of_people}명
                </div>
                <div className="customer-mypage__order-block-price">
                  결제금액: {order.payment_amount.toLocaleString()}원
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="customer-mypage__profile-block">
          <div className="customer-mypage__profile-block-item">
            <div className="customer-mypage__profile-block-text">아이디</div>
            <input 
              className="customer-mypage__profile-block-input" 
              value={userInfo?.user_login_id || ''} 
              disabled 
            />
          </div>
          <div className="customer-mypage__profile-block-item">
            <div className="customer-mypage__profile-block-text">이름</div>
            <input 
              className="customer-mypage__profile-block-input" 
              value={userInfo?.user_name || ''} 
              onChange={(e) => setUserInfo({...userInfo, user_name: e.target.value})} 
            />
          </div>
          <div className="customer-mypage__profile-block-item">
            <div className="customer-mypage__profile-block-text">이메일</div>
            <input 
              className="customer-mypage__profile-block-input" 
              value={userInfo?.user_email || ''} 
              onChange={(e) => setUserInfo({...userInfo, user_email: e.target.value})} 
            />
          </div>
          <div className="customer-mypage__profile-block-item">
            <div className="customer-mypage__profile-block-text">휴대폰</div>
            <input 
              className="customer-mypage__profile-block-input" 
              value={userInfo?.user_phone || ''} 
              onChange={(e) => setUserInfo({...userInfo, user_phone: e.target.value})} 
            />
          </div>

          <div className="customer-mypage__profile-block-item">
            <div className="customer-mypage__profile-block-text">관심 분야</div>
            <div className="customer-mypage__profile-block-interests">
              {[
                ['westernPainting', '서양화'],
                ['koreanPainting', '한국화'],
                ['folkPainting', '민화'],
                ['waterPainting', '수채화'],
                ['printPainting', '판화'],
                ['sculpture', '조각'],
                ['calligraphy', '서예'],
                ['craft', '공예'],
                ['picture', '사진'],
                ['illustration', '일러스트']
              ].map(([key, label]) => (
                <div key={key} className="customer-mypage__profile-block-interest-item">
                  <input
                    type="checkbox"
                    id={key}
                    checked={userInfo?.interests?.[key] || false}
                    onChange={(e) => setUserInfo({
                      ...userInfo,
                      interests: {
                        ...(userInfo?.interests || {}),
                        [key]: e.target.checked
                      }
                    })}
                  />
                  <label htmlFor={key}>{label}</label>
                </div>
              ))}
            </div>
          </div>

          <div className="customer-mypage__button-block">
            <div 
              className="customer-mypage__button-block-save"
              onClick={handleSave}
            >
              저장하기
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
